import { ICheckCaptureProcessor } from "interfaces";

export const checkCaptureProcessors: ICheckCaptureProcessor[] = [
  {
    id: 0,
    name: "Deluxe",
    active: true,
  },
  {
    id: 1,
    name: "Priority Commerce",
    active: true,
  },
];

export const processorConstants = {
  DELUXE: 0,
  PASSPORT: 1,
};
